import { Point, Editor } from 'slate';

export default function calculatePreviousPoint(editor: Editor, point: Point) {
    if (point.offset) return { ...point, offset: point.offset - 1 };
    let path = [...point.path];
    while (path[path.length - 1] === 0) path = path.slice(0, -1);
    if (!path.length) return point;
    return Editor.end(editor, path.slice(0, -1).concat(path.slice(-1)[0] - 1));
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('calculatePreviousPoint', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
